import { LowerRegions } from '@/modules/configs/region'
import { useDerivativeAccess } from '@/modules/useDerivativesAccess'

import {
  Defi,
  defi_uk,
  Exchange,
  exchange_uk,
  Products,
  products_desktop_uk,
  products_uk,
  Section,
} from './data'

export const useUpdatedMenu = (
  region: LowerRegions,
  products: Products[],
  exchange: Exchange[],
  defi: Defi[],
  products_desktop: Section[]
) => {
  const isDerivativeAccess = useDerivativeAccess()
  if (region === 'eea' && !isDerivativeAccess) {
    return {
      products: products_uk,
      exchange: exchange_uk,
      defi: defi_uk,
      products_desktop: products_desktop_uk,
    }
  }
  return {
    products,
    exchange,
    defi,
    products_desktop,
  }
}
